import Vue from 'vue'
import App from './App.vue'
import router from './router'
import wave from './components/canvas'
import axios from 'axios'
/* axios配置 */
//axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(wave)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js